module.exports = __webpack_public_path__ + "img/shrewd-save-5.c395c733.webp";